<template>
  <v-row class="flex-column text-center justify-center">
    <v-icon class="big-icon my-6" color="primary">error</v-icon>
    <div class="display primary--text font-weight-bold mb-12">
      {{ $t("payment.error.tip") }}
    </div>
    <v-btn
      color="primary"
      class="textOverSecondary--text semi-rounded my-6 mx-auto px-12 py-8"
      @click="redirectToHome"
    >
      {{ $t("payment.error.button") }}
    </v-btn>
  </v-row>
</template>
<script>
export default {
  props: ["routeNames"],
  methods: {
    redirectToHome() {
      const url = this.$router.resolve({ name: this.routeNames.RECHARGE });
      window.parent.location.href = url.href;
    },
  },
};
</script>
